// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendPasswordResetForm__sendPasswordResetForm___dnz>div,.SendPasswordResetForm__sendPasswordResetForm___dnz p{margin-bottom:10px}`, "",{"version":3,"sources":["webpack://./components/SendPasswordResetForm.scss"],"names":[],"mappings":"AAGE,8GAEE,kBAAA","sourcesContent":["@import \"../vars.scss\";\n\n.sendPasswordResetForm {\n  & > div,\n  p {\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sendPasswordResetForm": `SendPasswordResetForm__sendPasswordResetForm___dnz`
};
export default ___CSS_LOADER_EXPORT___;
